var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "100%",
    height: "100%",
    viewBox: "-1.92 -1.92 35.84 35.84",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.00032,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#ffffff",
    strokeWidth: 1.088
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.421l4.296 8.909 9.769 1.452-7.075 7.057 0.238 1.416 1.415 8.443-8.644-4.649-8.643 4.652 1.415-8.444 0.237-1.416-7.073-7.059 9.768-1.452 0.642-1.329zM15.999 0.486c-0.896 0-1.712 0.505-2.093 1.296l-3.622 7.52-8.335 1.239c-0.856 0.128-1.567 0.713-1.843 1.512-0.276 0.802-0.067 1.684 0.537 2.286l6.106 6.1-1.417 8.458c-0.143 0.852 0.226 1.707 0.949 2.206 0.397 0.273 0.864 0.411 1.332 0.411 0.385 0 0.77-0.093 1.119-0.281l7.266-3.912 7.266 3.912c0.349 0.187 0.735 0.281 1.118 0.281 0.468 0 0.934-0.138 1.333-0.411 0.722-0.498 1.091-1.353 0.947-2.206l-1.417-8.458 6.11-6.1c0.605-0.601 0.812-1.485 0.536-2.286s-0.988-1.385-1.843-1.512l-8.333-1.239-3.624-7.52c-0.378-0.791-1.195-1.295-2.093-1.295z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.421l4.296 8.909 9.769 1.452-7.075 7.057 0.238 1.416 1.415 8.443-8.644-4.649-8.643 4.652 1.415-8.444 0.237-1.416-7.073-7.059 9.768-1.452 0.642-1.329zM15.999 0.486c-0.896 0-1.712 0.505-2.093 1.296l-3.622 7.52-8.335 1.239c-0.856 0.128-1.567 0.713-1.843 1.512-0.276 0.802-0.067 1.684 0.537 2.286l6.106 6.1-1.417 8.458c-0.143 0.852 0.226 1.707 0.949 2.206 0.397 0.273 0.864 0.411 1.332 0.411 0.385 0 0.77-0.093 1.119-0.281l7.266-3.912 7.266 3.912c0.349 0.187 0.735 0.281 1.118 0.281 0.468 0 0.934-0.138 1.333-0.411 0.722-0.498 1.091-1.353 0.947-2.206l-1.417-8.458 6.11-6.1c0.605-0.601 0.812-1.485 0.536-2.286s-0.988-1.385-1.843-1.512l-8.333-1.239-3.624-7.52c-0.378-0.791-1.195-1.295-2.093-1.295z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.33d3ff9552bda6d9837aeff8bb06599c.svg";
export { ForwardRef as ReactComponent };